import { render, staticRenderFns } from "./DeliverExc.vue?vue&type=template&id=01ce64b3&scoped=true"
import script from "./DeliverExc.vue?vue&type=script&lang=js"
export * from "./DeliverExc.vue?vue&type=script&lang=js"
import style0 from "./DeliverExc.vue?vue&type=style&index=0&id=01ce64b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ce64b3",
  null
  
)

export default component.exports